/**
 * Application entry point.
 */

import { initTracing } from '@/lib/tracing';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialize OpenTelemetry tracing before any data-fetching code so that
// outbound `fetch()` calls carry a W3C `traceparent` header. Tracing must
// never break the app — wrap in try/catch and log on failure.
try {
  initTracing();
} catch (err) {
   
  console.error('[tracing] failed to initialize OpenTelemetry:', err);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
